/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/round_to.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Rounds down to one of a list of fixed points.
 *
 * @example
 * FROM employees
 * | STATS COUNT(*) BY birth_window=ROUND_TO(
 *     birth_date,
 *     "1900-01-01T00:00:00Z"::DATETIME,
 *     "1950-01-01T00:00:00Z"::DATETIME,
 *     "1955-01-01T00:00:00Z"::DATETIME,
 *     "1960-01-01T00:00:00Z"::DATETIME,
 *     "1965-01-01T00:00:00Z"::DATETIME,
 *     "1970-01-01T00:00:00Z"::DATETIME,
 *     "1975-01-01T00:00:00Z"::DATETIME
 * )
 * | SORT birth_window ASC
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'round_to',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'date',
          optional: false,
        },
        {
          name: 'points',
          type: 'date',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'field',
          type: 'date_nanos',
          optional: false,
        },
        {
          name: 'points',
          type: 'date_nanos',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'date_nanos',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
        {
          name: 'points',
          type: 'double',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
        {
          name: 'points',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'double',
          optional: false,
        },
        {
          name: 'points',
          type: 'long',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
        {
          name: 'points',
          type: 'double',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
        {
          name: 'points',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'integer',
    },
    {
      params: [
        {
          name: 'field',
          type: 'integer',
          optional: false,
        },
        {
          name: 'points',
          type: 'long',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
        {
          name: 'points',
          type: 'double',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
        {
          name: 'points',
          type: 'integer',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'long',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
        {
          name: 'points',
          type: 'long',
          optional: false,
          hint: {
            kind: 'constant',
          },
        },
      ],
      variadic: true,
      returnType: 'long',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
